import * as React from 'react';
import styled from 'styled-components';
import {darken, lighten, transparentize} from 'polished';
import {transition} from 'helpers/css';
import outline from 'helpers/outline';
import {IconPlus} from 'icons';

export interface AddButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onAdd?(): void;
}

const Container = styled.div`
  grid-auto-flow: column;
  display: inline-grid;
  
  ${transition()};
  overflow: hidden;
  border-radius: 5px;
  background: ${({theme}) => `
    ${transparentize(.95, theme.colors.white)};
  `};
  
  &:hover,
  &:focus-visible {
    background: ${({theme}) => theme.colors.primary};
  }
`;

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: grid;

  height: 22px;
  width: 22px;

  ${transition()};
  border-radius: 5px;
  background: ${({theme}) => `
    ${transparentize(.85, theme.colors.black)};
  `};
`;

const AddContainer = styled.button`
  padding: 6px 0 6px 6px;
  
  &:hover {
    ${IconContainer} {
      background: ${({theme}) => `
        ${transparentize(.85, theme.colors.white)};
      `};
    }
  }

  &:active {
    ${IconContainer} {
      background: ${({theme}) => `
        ${transparentize(.65, theme.colors.white)};
      `};
    }
  }
`;

const ButtonContainer = styled.button`
  padding: 0 10px 0 8px;
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
`;

const Label = styled.span`
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
`;

/**
 * This component renders the add content button or creates one
 * @param {AddButtonProps} props
 * @constructor
 */
export default function AddButton(
    props: AddButtonProps,
): React.ReactElement<AddButtonProps> {
  return (
    <Container>
      <AddContainer>
        <IconContainer onClick={() => props.onAdd && props.onAdd()}>
          <IconPlus />
        </IconContainer>
      </AddContainer>
      <ButtonContainer {...props}>
        <Label>
          {props.children}
        </Label>
      </ButtonContainer>
    </Container>
  );
}
